// extracted by mini-css-extract-plugin
export default {"aiBtn":"AIToolbarButton_aiBtn__AHgge","label":"AIToolbarButton_label__CHYs8"};